<template>
  <div id="scheduleApp">
    <component :is="view" />
    <div :class="`category-${mediaquery}`" style="padding-top: 2rem; font-size: 1.4rem;">
      {{ priceText }}
    </div>
    <div id="tooltip" class="tooltipContainer" style="display: none;"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

var _each = require('lodash/each')

export default {
  name: 'SchedulesApp',
  created () {
    this.setInitData(window.initData)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    this.setMediaqueryKey(this.getMediaqueryKey())
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState({
      media: state => state.media,
      mediaquery: state => state.mediaqueryKey,
      objectData: state => state.objectData
    }),
    view () {
      return this.mediaquery > 3 ? 'pmSchedulesDesktop' : this.mediaquery === 1 ? 'pmSchedulesMobile' : 'pmSchedulesTablet'
    },
    priceText () {
      if (this.objectData.text_preis_info && this.objectData.text_preis_info !== '') {
        return this.objectData.text_preis_info;
      } else {
        return this.$t('deck.price-note')
      }
    }
  },
  methods: {
    ...mapMutations({
      setInitData: 'SET_INIT_DATA',
      setMediaqueryKey: 'SET_MEDIAQUERY_KEY'
    }),
    handleResize () {
      this.setMediaqueryKey(this.getMediaqueryKey())
    },
    getMediaqueryKey () {
      let mediaKey = 4
      _each(this.media, (val, key) => {
        if (window.matchMedia(val).matches) {
          mediaKey = parseInt(key)
        }
      })
      return mediaKey
    }
  },
  components: {
    pmSchedulesDesktop: () => import(`@/views/SchedulesDesktop.vue`),
    pmSchedulesTablet: () => import(`@/views/SchedulesTablet.vue`),
    pmSchedulesMobile: () => import(`@/views/SchedulesMobile.vue`)
  }
}
</script>
